import { render, staticRenderFns } from "./enrollmentResultIndex.vue?vue&type=template&id=65cb340d&scoped=true&"
import script from "./enrollmentResultIndex.vue?vue&type=script&lang=js&"
export * from "./enrollmentResultIndex.vue?vue&type=script&lang=js&"
import style0 from "./enrollmentResultIndex.vue?vue&type=style&index=0&id=65cb340d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb340d",
  null
  
)

export default component.exports